import { Employee } from '../../model/inko-backend.model'

/**
 * Ob der Willkommensdialog kommt: einmal je Konto, sobald es eine Rolle hat, bis „Speichern“ oder
 * „Später“ geklickt ist (`willkommenErledigt` am Mitarbeiter). Das gilt bewusst auch fuer alle, die
 * schon vor dem 2026-09-29 da waren: bei ihnen ist der Name fast immer der Teil vor dem @.
 *
 * SaniUp-Konten bekommen ihn auf PROD nicht: sie springen zwischen vielen Leistungserbringern und
 * haben dort je ein eigenes Mitarbeiter-Dokument, der Dialog kaeme also bei jedem neuen. Auf TST
 * und DEMO schon, sonst liesse er sich nicht ausprobieren.
 */
export function willkommenZeigen(ich: Pick<Employee, 'roles' | 'willkommenErledigt'>, saniup: boolean, prod: boolean): boolean {
  return ich.roles.length > 0 && !ich.willkommenErledigt && !(saniup && prod)
}

/** Ein Konto aus den letzten zwei Tagen: dann „Willkommen“, sonst „Neu: Ihr Profil“. */
export function istNeuesKonto(ich: Pick<Employee, 'createdDate'>, jetzt: Date): boolean {
  if (!ich.createdDate) return true
  const angelegt = Date.parse(ich.createdDate)
  return Number.isNaN(angelegt) || jetzt.getTime() - angelegt < 2 * 24 * 60 * 60 * 1000
}
